import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { VendorActions } from '../store/vendor/vendor.action';
import { VendorQuery } from '../store/vendor/vendor.query';

@Injectable({
  providedIn: 'root',
})
export class RegistrationGuard  {
  public constructor(
    private vendorQuery: VendorQuery,
    private vendorActions: VendorActions,
    private router: Router
  ) {}

  public canActivate(): Observable<boolean | UrlTree> {
    this.vendorActions.getVendorData();
    return this.vendorQuery
      .select((v) => v.vendor)
      .pipe(
        first((v) => !!v),
        map((v) => {
          if (!v.name) {
            return this.router.parseUrl('/registration');
          }

          return true;
        })
      );
  }
}
